import {
  COMPLIANCE_IA_GROUPS,
  COMPLIANCE_IA_ROUTES,
  resolveGroupVisibility,
  type ObligationStatuses,
} from '@statura/utils/compliance-ia';

/** Presentation only: unknown and provider-mediated obligations keep their doors. */
export function isComplianceNavRouteApplicable(
  href: string,
  statuses: ObligationStatuses,
): boolean {
  const route = COMPLIANCE_IA_ROUTES.find((candidate) => candidate.href === href);
  if (!route) return true;
  const group = COMPLIANCE_IA_GROUPS.find((candidate) =>
    candidate.routes.some((member) => member.href === href),
  );
  if (group && !resolveGroupVisibility(group, statuses)) return false;
  return !(
    route.obligationIds.length > 0 &&
    route.obligationIds.every((id) => {
      const resolution = Array.isArray(statuses)
        ? statuses.find((item) => item.obligationId === id)
        : 'get' in statuses
          ? (statuses as ReadonlyMap<string, string | { status: string } | undefined>).get(id)
          : (statuses as Readonly<Record<string, string | { status: string } | undefined>>)[id];
      return (
        (typeof resolution === 'string' ? resolution : resolution?.status) === 'DOES_NOT_APPLY'
      );
    })
  );
}
